module.exports = __webpack_public_path__ + "img/840.e0555172.svg";